import React, { FC, useState } from 'react';
import { View, ScrollView } from 'react-native';
import { SETTINGS_SECTIONS } from './sections';
import SettingsTopBar from './SettingsTopBar';
import SettingsSidebar from './SettingsSidebar';
import { SettingsSyncProvider } from './SettingsSyncContext';
import SettingsShellStyles from './SettingsScreen.styles';

const SettingsScreen: FC = () => {
  const styles = SettingsShellStyles();
  const [selectedSectionId, setSelectedSectionId] = useState(
    SETTINGS_SECTIONS[0].id,
  );

  const activeSection =
    SETTINGS_SECTIONS.find(section => section.id === selectedSectionId) ||
    SETTINGS_SECTIONS[0];
  const ActivePanel = activeSection.Component;

  return (
    <SettingsSyncProvider>
      <View style={styles.screen} ph-label="settings-screen">
        <SettingsTopBar />
        <View style={styles.body}>
          <SettingsSidebar
            selectedSectionId={selectedSectionId}
            onSelectSection={setSelectedSectionId}
          />
          {/* Scrolls because a panel can exceed the viewport — many timer
              milestones, a long printer list — as the screen this replaced did.
              Keying on the section remounts it, so switching sections starts at
              the top instead of inheriting the previous panel's scroll offset. */}
          <ScrollView
            style={styles.content}
            testID="settings-content"
            key={selectedSectionId}
          >
            <ActivePanel />
          </ScrollView>
        </View>
      </View>
    </SettingsSyncProvider>
  );
};

export default SettingsScreen;
